import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { QueryParams } from '../api.service';
import { StorageAPIService } from '../storage-api.service';

export interface ContentChannel {
  id: string;
  label: string;
  children?: ContentChannel[];
  properties?: ContentChannelProperties;
}

export interface ContentChannelProperties {
  enabled: boolean;
  label_fr: string;
  label_de: string;
  label_it: string;
  label_ja: string;
  label_ko: string;
  label_pt: string;
  label_es: string;
  label_bn: string;
}

@EnableClassTelemetry()
@Injectable({ providedIn: 'root' })
export class ContentChannelService extends StorageAPIService {
  getContentChannels(id = 'root', depth = -1): Promise<ContentChannel> {
    const endpoint = `/content-channels/${id}`;
    const queryParams: QueryParams = { depth };

    return this.get<ContentChannel>(endpoint, queryParams);
  }

  getContentChannelParentTree(id: string): Promise<ContentChannel[]> {
    const endpoint = `/content-channels/${id}/parent-tree`;

    return this.get<ContentChannel[]>(endpoint);
  }
}
